import ValueAnalysis_ResultsPage from "@Evaluation/ValueAnalysis/Pages/ResultsPage.vue";

import { routes as criteriaSurveysRoutes } from "@Evaluation/CriteriaSurveys/routes";
import { routes as alternativesSurveysRoutes } from "@Evaluation/AlternativesSurveys/routes";
import { routes as evalModelsRoutes } from "@Evaluation/EvaluationModels/routes";
import { routes as estimationsRoutes } from "@Evaluation/Estimations/routes";


export const routes = [
    ...evalModelsRoutes,
    ...criteriaSurveysRoutes,
    ...alternativesSurveysRoutes,
    ...estimationsRoutes,
    {
        path: "/pp/results/:workspaceId/:projectId/:evalModelId",
        component: ValueAnalysis_ResultsPage,
    },
]
